namespace TabAurous.Inventory {
    export namespace MaterialRequestService {
        export const baseUrl = 'Inventory/MaterialRequest';

        export declare function Create(request: Serenity.SaveRequest<MaterialRequestRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CreateFromMRPReport(request: MRPRow[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MaterialRequestRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MaterialRequestRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MaterialRequestRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/MaterialRequest/Create",
            CreateFromMRPReport = "Inventory/MaterialRequest/CreateFromMRPReport",
            Update = "Inventory/MaterialRequest/Update",
            Delete = "Inventory/MaterialRequest/Delete",
            Retrieve = "Inventory/MaterialRequest/Retrieve",
            List = "Inventory/MaterialRequest/List"
        }

        [
            'Create', 
            'CreateFromMRPReport', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>MaterialRequestService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
